<app-lfsa-card-v2 *ngIf="!mostrarFormulario" [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate"
                  [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
  <div class="col-md-6">
    <div class="pagetitle">
      <div class="btn-group-justified btn-group" style="float: right;">
        <a (click)="nuevo()" class="btn btn-outline-success">
          <span class="fa fa-plus"></span>
          {{ DAT_TITULOS.nuevo }}
        </a>
        <a class="btn btn-outline-warning btn-outline"><i class="far fa-file-excel"></i></a>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #enviarTemplate>
  <!-- <br> -->
  <section class="section">
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading" [texto]="DAT_TITULOS.listaVacia">
        </app-lfsa-alerts>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                         [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                         [pagination]="true"
                         [rowData]="rowData" [rowSelection]="rowSelection" [style]="modulo.agGrid.style"
                         class="ag-theme-alpine" [paginationPageSize]="modulo.agGrid.paginacion">
        </ag-grid-angular>
      </div>
    </div>
  </section>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm" [modulo]="DAT_TITULOS.modulo"
                  [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #enviarTemplateForm>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div class="row">
      <div class="form-group col-md-4">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('cliCodigobaan')" [id]="'cliCodigobaan'"
                        [label]="'Código Baan*'" [placeholder]="'Ingrese Código Baan'"
                        formControlName="cliCodigobaan"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('cliRuc')" [id]="'cliRuc'"
                        [label]="'Ruc*'" [placeholder]="'Ingrese Ruc'" formControlName="cliRuc"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('cliNombre')" [id]="'cliNombre'"
                        [label]="'Nombres*'" [placeholder]="'Ingrese Nombres'"
                        formControlName="cliNombre"></app-lfsa-input>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('cliFono')" [id]="'cliFono'"
                        [label]="'Teléfono*'" [placeholder]="'Ingrese Teléfono'"
                        formControlName="cliFono"></app-lfsa-input>
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('cliEmail')" [id]="'cliEmail'"
                        [label]="'Email*'"
                        [placeholder]="'Ingrese Email'" [type]="'email'"
                        formControlName="cliEmail"></app-lfsa-input>
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('cliDir')" [id]="'cliDir'"
                        [label]="'Dirección*'" [placeholder]="'Ingrese Dirección'" formControlName="cliDir"></app-lfsa-input>
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbEstado"
                            [control]="formulario.get('cliEstado')" [idOpcion]="'clave'" [id]="'cliEstado'"
                            [label]="'Estado*'"
                            [opcion]="'valor'" formControlName="cliEstado"></app-lfsa-combo-box>
      </div>
    </div>
    <br>
    <app-lfsa-botones-formulario (devolverAccion)="acciones ( $event )" [formularioValido]="formulario.invalid"
                                 [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </form>
</ng-template>
